import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  BulletPointText,
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import type { LinkPressProps } from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { HStack, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface TextCrisisNumberSectionProps {
  onLinkPress: (props: LinkPressProps) => void;
  phoneNumber?: string;
  url?: string;
}

const TextCrisisNumberSection = ({
  onLinkPress,
  phoneNumber,
  url,
}: TextCrisisNumberSectionProps) => {
  const textSuicideLine = [
    <VStack gap={0} key={SafetyPlanTestID.TextSuicideLine}>
      {phoneNumber && (
        <HStack>
          <BulletPointText
            isFlexShrink={false}
            testID={joinTestIDs(SafetyPlanTestID.TextSuicideLine, "text-home")}
            text='Text "HOME" to '
          />
          <LinkText
            linkType="sms"
            onPress={() => {
              onLinkPress({
                field: joinTestIDs(TextCrisisNumberSection.name, "sms"),
                linkType: "sms",
                text: phoneNumber,
              });
            }}
            testID={joinTestIDs(
              SafetyPlanTestID.TextSuicideLine,
              "crisis-number",
            )}
            text={phoneNumber}
          />
          <BulletPointText
            isFlexShrink={false}
            testID={joinTestIDs(SafetyPlanTestID.TextSuicideLine, "to-connect")}
            text=" to connect with a Crisis "
          />
        </HStack>
      )}
      {url && (
        <HStack>
          <BulletPointText
            testID={joinTestIDs(SafetyPlanTestID.TextSuicideLine, "counselor")}
            text="Counselor - "
          />
          <LinkText
            linkType="web"
            onPress={() => {
              onLinkPress({
                field: joinTestIDs(TextCrisisNumberSection.name, "url"),
                linkType: "web",
                text: url,
              });
            }}
            testID={joinTestIDs(SafetyPlanTestID.TextSuicideLine, "crisis-url")}
            text={url}
          />
        </HStack>
      )}
    </VStack>,
  ];

  return (
    <SafetyPlanSection
      statements={textSuicideLine}
      testID={joinTestIDs(SafetyPlanTestID.TextSuicideLine, "section")}
      title="Text suicide line"
    />
  );
};

export default TextCrisisNumberSection;
